import { render, staticRenderFns } from "./bgjlInfo.vue?vue&type=template&id=2264017b&scoped=true"
import script from "./bgjlInfo.vue?vue&type=script&lang=js"
export * from "./bgjlInfo.vue?vue&type=script&lang=js"
import style0 from "./bgjlInfo.vue?vue&type=style&index=0&id=2264017b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264017b",
  null
  
)

export default component.exports